import React from 'react';

import { colorsPalette } from '../../theme';
import useStyles from './styles';

const StarIcon = (props) => {
  const color = props?.color || colorsPalette.white;
  const classes = useStyles()();
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
      color={color}
    >
      <polygon
        className={classes.element}
        points="12 2 15.119 8.762 22.515 9.64 17.047 14.696 18.498 22 12 18.362 5.502 22 6.953 14.696 1.485 9.64 8.881 8.762 12 2"
      />
    </svg>
  );
};
export default StarIcon;
